itsoftApp.createModule("youtubeVideo", ["pageLoad"], function() {
    var module = this;

    var init = function () {
        var playButtons = document.querySelectorAll('.js-video-yt');
        var activePlayer;
        var players = [];
        var initialized = false;
        var firstDataPopup;
        var firstVideoContainer;
        var playerIndex;
        var queue = {                        
            content: playVideo,
            push: function(fn) {
                this.content = fn;
            },
            pop: function() {
                this.content.call();
                this.content = null;
            }
        }

        var videoContainerCoordYTop;;
        var videoContainerCoordYBottom;

        var defineCoordY = function () {
            videoContainerCoordYTop = activePlayer.f.getBoundingClientRect().top + pageYOffset;
            videoContainerCoordYBottom = activePlayer.f.getBoundingClientRect().bottom + pageYOffset;
        }

        var checkElementCoords = function () {
            var s_top = pageYOffset;

            if (videoContainerCoordYBottom < s_top || videoContainerCoordYTop > s_top + document.documentElement.clientHeight) {
                pauseVideo();
            }
        }

        var onWindowScroll = function () {
            checkElementCoords();
        }

        var onWindowResize = function () {
            defineCoordY();
            checkElementCoords();
        }

        function isPlayerReady() {
            return activePlayer && typeof activePlayer.playVideo === "function";
        }

        function playVideo() {
            if (isPlayerReady()) {
                activePlayer.playVideo();
                if (!activePlayer.dataPopup) {
                    defineCoordY();
                    var videoSection = activePlayer.f.closest(".js-video-section");
                    videoSection.classList.add("js-video-section--active");
                    window.addEventListener("scroll", onWindowScroll);
                    window.addEventListener("resize", onWindowResize);
                }
            } else {
                queue.push(function() {
                    activePlayer.playVideo();
                    if (!activePlayer.dataPopup) {
                        defineCoordY();
                        var videoSection = activePlayer.f.closest(".js-video-section");
                        videoSection.classList.add("js-video-section--active");
                        window.addEventListener("scroll", onWindowScroll);
                        window.addEventListener("resize", onWindowResize);
                    }
                });
            }
        }

        function pauseVideo() {
            if (isPlayerReady()) {
                if (!activePlayer.dataPopup) {
                    var videoSection = activePlayer.f.closest(".js-video-section");
                    videoSection.classList.remove("js-video-section--active");
                    window.removeEventListener("scroll", onWindowScroll);
                    window.removeEventListener("resize", onWindowResize);
                }
                activePlayer.pauseVideo();
            } else {
                queue.push(function() {
                    if (!activePlayer.dataPopup) {
                        var videoSection = activePlayer.f.closest(".js-video-section");
                        videoSection.classList.remove("js-video-section--active");
                        window.removeEventListener("scroll", onWindowScroll);
                        window.removeEventListener("resize", onWindowResize);
                    }
                    activePlayer.pauseVideo();
                });
            }
        }

        var onPlayerReady = function (event) {
            initialized = true;
            activePlayer = players[+playerIndex];
            activePlayer.dataPopup = firstDataPopup;
            activePlayer.videoContainer = firstVideoContainer;

            playVideo();
        }

        window.onYouTubeIframeAPIReady = function () {
            var options = {
                playerVars: {"rel": 0, "enablejsapi": 1, "origin": window.location.origin},
                host: window.location.protocol + "//www.youtube.com"
            }

            for (var i = 0; i < playButtons.length; i++) {
                var playButton = playButtons[i];
                var videoPlaceId = playButton.getAttribute("data-video-place");
                var videoLink = playButton.getAttribute("data-video-source");
                var videoLinkSubstringIndex = videoLink.lastIndexOf("/");
                var videoId = videoLink.substring(videoLinkSubstringIndex + 1, videoLink.length);

                if (i === playButtons.length - 1) {
                    options.events = {
                        "onReady": onPlayerReady
                    }
                }

                options.videoId = videoId;

                players[i] = new YT.Player(videoPlaceId, options);
            }
        }

        var initYoutube = function (playButton, index) {
            var videoInline = playButton.hasAttribute("data-video-inline");
            var dataPopupInline = playButton.getAttribute("data-popup-selector");
            var videoContainerInline;
            var onPlayButtonClick = function (dataPopup, videoContainer) {
                if (!dataPopup) {
                    dataPopup = dataPopupInline;
                }

                if (!videoContainer) {
                    videoContainer = videoContainerInline;
                }

                playerIndex = index;

                if (!initialized) {
                    firstDataPopup = dataPopup;
                    firstVideoContainer = videoContainer;
                    var tag = document.createElement('script');
                    tag.src = window.location.protocol + "//www.youtube.com/iframe_api"; //player_api
                    document.body.appendChild(tag);
                } else {
                    activePlayer = players[+playerIndex];
                    activePlayer.dataPopup = dataPopup;
                    activePlayer.videoContainer = videoContainer;
                    playVideo();
                }
            }

            if (!videoInline) {
                itsoftApp.modules.popups.callback.createYoutube(playButton, playVideo, pauseVideo, onPlayButtonClick);
            } else {
                var videoPlaceId = playButton.getAttribute("data-video");
                videoContainerInline = document.querySelector("#" + videoPlaceId);
                playButton.addEventListener("click", onPlayButtonClick);
            }
        }

        if (playButtons) {
            for (var i = 0; i < playButtons.length; i++) {
                initYoutube(playButtons[i], i);
            }
        }
    }

    module.callback = init;
});
